// extracted by mini-css-extract-plugin
export var conversationListItem = "_wj-2";
export var fullBleedList = "_wj-3";
export var messageText = "_wj-1";
export var previewText = "_wj-0";